import React, { FC, useMemo } from 'react';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { isFieldString, TenderBlockSize, TenderBoxMode, TenderSubCatName } from 'src/models/procurements/Tender/types';
import { TenderBox, TenderSubCat } from 'src/shared';
import { FeatureFlag, useFeatureFlag } from 'src/helpers';

export const CustomSubCat: FC = () => {
  const { data } = useTenderData();
  const customBoxes = data?.customBoxes;
  const subCat = useMemo(() => data?.generalCat[TenderSubCatName.Custom], [data]);
  const isEditable = !!data?.isEditable;
  const isCustomBidFieldsFeature = useFeatureFlag(FeatureFlag.CustomBidFields);

  return (
    <>
      {isCustomBidFieldsFeature && isEditable && customBoxes && !!customBoxes.length && subCat && (
        <TenderSubCat subCat={{ ...subCat, size: TenderBlockSize.Full }}>
          {customBoxes.map(box => (
            <TenderBox
              title={box.title}
              isEditable={true}
              actions={false}
              boxes={[box]}
              as={TenderBoxMode.Collection}
              key={box.id}
              size={isFieldString(box.firstField) ? TenderBlockSize.Full : TenderBlockSize.Quarter}
            />
          ))}
        </TenderSubCat>
      )}
    </>
  );
};

export default CustomSubCat;
